import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ViewChild,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
} from '@angular/core';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import * as fromHome from './../../../screens/home/state/home.selectors';
import * as HomeAction from './../../../screens/home/state/home.actions';
import { slideInDownAnimation } from '../../../app/app.animation';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { LGEDataService } from '../../services/data.service';
import { AngularMaterialService } from '../../utilities/angular.material.service';
import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ccms-table-ext-component',
  templateUrl: './ccms-table-ext.component.html',
  styleUrls: ['./ccms-table-ext.component.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CCMSTableExtComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input('isLoading') isLoading: boolean = true;
  @Input('data') data: any[];
  @Input('displayedColumns') displayedColumns: any[];
  @Input('tableName') tableName: string = '';
  datePipe = new DatePipe('en-US');
  isPrinting = false;
  selection = new SelectionModel<any>(true, []);
  isAllChecked: boolean = false;
  isIndeterminate: boolean = false;
  validId = null;
  type = '';
  isIntSelected: boolean = false;

  dataSource: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef,
    private store: Store<fromHome.State>,
    private lgeDataService: LGEDataService,
    private ams: AngularMaterialService,
    private spinner: NgxSpinnerService
  ) {}

  public ngOnInit() {
    this.spinner.show(this.tableName);
    setTimeout(() => {
      this.data.forEach((d) => (d.checked = false));
      this.dataSource = new MatTableDataSource(this.data);
      // Sorting nested object
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'requestNo':
            return item.formID;
          case 'grantName':
            return item.grantName.toLowerCase();
          case 'formName':
            return item.formName.toLowerCase();
          case 'orgName':
            return item.orgName.toLowerCase();
          case 'dateRequest':
            return moment(item.dateRequest);
          case 'amount':
            return +item.amount;
          case 'status':
            return item.status.toLowerCase();
          case 'Adminstatus':
            return item.statusDescrAdmin.toLowerCase();
          case 'subsection':
            return this.getTaxExemptStatus(item.subsection);
          default:
            return item[property];
        }
      };

      this.dataSource.filterPredicate = (data, filter: string) => {
        const accumulator = (currentTerm: string, key: string | number) => {
          switch (key) {
            case 'dateRequest':
              return (
                currentTerm +
                this.datePipe
                  .transform(data.dateRequest, 'MM-dd-yyyy')
                  ?.toString()
              );
            case 'subsection':
              return currentTerm + this.getTaxExemptStatus(data.subsection);
            default:
              return currentTerm + data[key];
          }
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        // Transform the filter by converting it to lowercase and removing whitespace.
        const transformedFilter = filter.trim().toLowerCase();
        return dataStr.includes(transformedFilter);
      };
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      setTimeout(() => {
        this.dataSource = new MatTableDataSource(changes['data'].currentValue);
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'requestNo':
              return item.formID;
            case 'grantName':
              return item.grantName.toLowerCase();
            case 'formName':
              return item.formName.toLowerCase();
            case 'orgName':
              return item.orgName.toLowerCase();
            case 'dateRequest':
              return moment(item.dateRequest);
            case 'amount':
              return +item.amount;
            case 'status':
              return item.status.toLowerCase();
            case 'Adminstatus':
              return item.statusDescrAdmin.toLowerCase();
            case 'subsection':
              return this.getTaxExemptStatus(item.subsection);
            default:
              return item[property];
          }
        };

        this.dataSource.filterPredicate = (data, filter: string) => {
          const accumulator = (currentTerm: string, key: string | number) => {
            switch (key) {
              case 'dateRequest':
                return (
                  currentTerm +
                  this.datePipe
                    .transform(data.dateRequest, 'MM-dd-yyyy')
                    ?.toString()
                );
              case 'subsection':
                return currentTerm + this.getTaxExemptStatus(data.subsection);
              default:
                return currentTerm + data[key];
            }
          };
          const dataStr = Object.keys(data)
            .reduce(accumulator, '')
            .toLowerCase();
          // Transform the filter by converting it to lowercase and removing whitespace.
          const transformedFilter = filter.trim().toLowerCase();
          return dataStr.includes(transformedFilter);
        };
        if (changes['isLoading'] !== undefined) {
          this.isLoading = changes['isLoading'].currentValue;
          if (this.isLoading) this.spinner.show();
          else this.spinner.hide();
        }
        if (changes['displayedColumns'] !== undefined) {
          this.displayedColumns = changes['displayedColumns'].currentValue;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }
  }

  isVisible(row: {
    requestNo: string;
    status: string;
    statusId: number;
    formLogId: null;
  }) {
    switch (row.requestNo.substring(0, 2)) {
      case 'CC':
        this.isIntSelected = true;
        return ['Withdrawn', 'Draft'].includes(row.status);
      case 'MG':
        this.isIntSelected = true;
        return ['Withdrawn', 'Draft'].includes(row.status);
      case 'CG':
        this.isIntSelected = false;
        return [7, 8, 9].includes(row.statusId) && row.formLogId !== null;
      case 'ES':
        this.isIntSelected = false;
        return [7, 8, 9].includes(row.statusId) && row.formLogId !== null;
      case 'PP':
        this.isIntSelected = false;
        return [7, 8, 9].includes(row.statusId) && row.formLogId !== null;
      default:
        this.isIntSelected = false;
        return true;
    }
  }

  formDataChecked(row: any) {
    this.selection.toggle(row);
  }

  ClearSelection() {
    this.selection.clear();
  }

  DeleteFormInt() {
    if (this.selection.selected.length > 0) {
      let filteredList = this.filterFormIntList(this.selection.selected);
      if (filteredList.length > 0) {
        this.type = 'INT';
        this.ams.showConfirm(
          'Are you sure you want to Delete selected applications ?',
          ''
        );
        this.ams.confirm.afterClosed().subscribe((result) => {
          if (result === 'yes') {
            this.ams.showLoader('Deleting...');
            this.DeleteFormIntList(filteredList);
          }
        });
      } else {
        this.ams.showAlert(
          'Invalid Selection!',
          'Please select applications with status "Draft" or "Withdrawn"!'
        );
      }
    }
  }

  filterFormIntList(formIntList: any[]) {
    return formIntList.filter(
      (f: { status: string }) =>
        f.status === 'Withdrawn' || f.status === 'Draft'
    );
  }

  DeleteFormIntList(finalSelection: any) {
    this.lgeDataService.DeleteFormIntList(finalSelection).subscribe({
      next: (result) => this.postIntRequest(),
      error: (error: Error) => {
        this.ams.closeDialog();
        this.ams.showAlert('Error!', 'Please try again later!');
        this.ref.markForCheck();
      },
    });
  }

  postIntRequest() {
    this.ams.closeDialog();
    this.ams.showAlert('Success!', 'Successfully Deleted!');
    this.ref.markForCheck();
    let leaving = setTimeout(() => {
      this.updateList();
    }, 5000);
    this.ams.alert.afterClosed().subscribe(() => {
      this.updateList();
      clearTimeout(leaving);
    });
  }

  ApproveRejectFormExtList(action: string) {
    if (
      this.selection.selected.length > 0 &&
      this.selection.selected.filter(
        (f) => f.status !== 'Withdrawn' || f.status !== 'Draft'
      ).length > 0
    ) {
      this.validId = this.selection.selected[0].statusId;
      let index: number = this.selection.selected.findIndex(
        (f) => f.statusId !== this.validId
      );
      if (index > -1) {
        this.ams.showAlert(
          'Invalid Selection!',
          'Please select applications with same approval level!'
        );
      } else {
        this.type = this.selection.selected[0].requestNo.substring(0, 2);
        this.processExtRequest(0, action).then(() => {
          let finalSelection = this.selection.selected.filter(
            (f) => f.approved === true
          );
          if (finalSelection.length > 0) {
            this.ams.showConfirm(
              'Are you sure you want to ' + action + ' selected applications ?',
              ''
            );
            this.ams.confirm.afterClosed().subscribe((result: string) => {
              if (result === 'yes') {
                console.log('selection: ', finalSelection);
                this.ams.showLoader(
                  `${action === 'Approve' ? 'Approving...' : 'Rejecting...'}`
                );
                if (this.type === 'PP') {
                  this.ApproveRejectFormPPList(finalSelection, action);
                } else if (this.type === 'CG') {
                  this.ApproveRejectFormCGList(finalSelection, action);
                } else {
                  this.ApproveRejectFormESList(finalSelection, action);
                }
              } else {
                this.selection = new SelectionModel<any>(true, []);
                if (this.type === 'PP') {
                  this.store.dispatch(
                    new HomeAction.LoadFormPPExceptDraftState()
                  );
                } else if (this.type === 'CG') {
                  this.store.dispatch(
                    new HomeAction.LoadFormCGExceptDraftState()
                  );
                } else {
                  this.store.dispatch(
                    new HomeAction.LoadFormESExceptDraftState()
                  );
                }
              }
            });
          }
        });
      }
    } else {
      this.ams.showAlert(
        'Invalid Selection!',
        'Please select at least one application!'
      );
    }
  }

  private processExtRequest(i: number, action: string): Promise<any> {
    return new Promise((resolve) => {
      if (i < this.selection.selected.length) {
        if (this.selection.selected.length > 0) {
          let info: any = {};
          info.title =
            this.type === 'PP'
              ? ' Selected Plant for the Planet '
              : this.type === 'CG'
              ? ' Selected Community Grants'
              : ' Selected Event Sponsorship';
          info.type = this.type;
          info.action = action;
          let selectedRequest: any = {};
          selectedRequest.formID = this.selection.selected[i].formID;
          selectedRequest.requestNumber = this.selection.selected[i].requestNo;
          selectedRequest.requestName = this.selection.selected[i].formName;
          selectedRequest.amount = this.selection.selected[i].amount;
          selectedRequest.comment = this.selection.selected[i].comment;
          selectedRequest.statusId = this.selection.selected[i].statusId;
          selectedRequest.AccDistribution =
            this.selection.selected[i].AccDistribution;
          this.ams.showProcessExternalRequest(
            action + info.title,
            '',
            selectedRequest,
            info
          );
          this.ams.processExternalRequest
            .afterClosed()
            .subscribe((result: any) => {
              if (result) {
                if (result !== 'Skip') {
                  this.selection.selected[i].amount = result.amount;
                  this.selection.selected[i].comment = result.comment;
                  this.selection.selected[i].approved = true;
                  this.selection.selected[i].AccDistribution =
                    result.AccDistribution;
                  this.selection.selected[i].action =
                    action === 'Approve' ? 'Approved' : 'Rejected';
                } else {
                  // this.selection.deselect(this.selection.selected[i]);
                }
                this.processExtRequest(i + 1, action).then((result) => {
                  resolve(result);
                });
              }
            });
        }
      } else {
        resolve('Done');
      }
    });
  }

  ApproveRejectFormPPList(finalSelection: any[], action: any) {
    this.lgeDataService.ApproveRejectFormPPList(finalSelection).subscribe({
      next: (result) => {
        this.postRequest(action);
      },
      error: (error: Error) => {
        this.ams.closeDialog();
        this.ams.showAlert('Error!', 'Please try again later!');
        this.ref.markForCheck();
      },
    });
  }

  ApproveRejectFormCGList(finalSelection: any[], action: any) {
    this.lgeDataService.ApproveRejectFormCGList(finalSelection).subscribe({
      next: (result) => this.postRequest(action),
      error: (err) => {
        this.ams.closeDialog();
        this.ams.showAlert('Error!', 'Please try again later!');
        this.ref.markForCheck();
      },
    });
  }

  ApproveRejectFormESList(finalSelection: any[], action: any) {
    this.lgeDataService.ApproveRejectFormESList(finalSelection).subscribe({
      next: (result) => this.postRequest(action),
      error: (err) => {
        this.ams.closeDialog();
        this.ams.showAlert('Error!', 'Please try again later!');
        this.ref.markForCheck();
      },
    });
  }

  postRequest(action: string) {
    this.ams.closeDialog();
    this.ams.showAlert(
      'Success!',
      'Successfully ' + `${action === 'Approve' ? 'Approved' : 'Rejected'}!`
    );
    this.ref.markForCheck();
    let leaving = setTimeout(() => {
      this.updateList();
    }, 5000);
    this.ams.alert.afterClosed().subscribe(() => {
      this.updateList();
      clearTimeout(leaving);
    });
  }

  private updateList() {
    this.selection = new SelectionModel<any>(true, []);
    switch (this.type) {
      case 'PP':
        this.store.dispatch(new HomeAction.LoadFormPPExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormPPPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormPPApprovedState());
        break;
      case 'CG':
        this.store.dispatch(new HomeAction.LoadFormCGExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormCGPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormCGApprovedState());
        break;
      case 'ES':
        this.store.dispatch(new HomeAction.LoadFormESExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormESPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormESApprovedState());
        break;
      case 'INT':
        this.store.dispatch(new HomeAction.LoadUserIntState());
        this.store.dispatch(new HomeAction.LoadFormCCExceptDraftState());
        break;
    }
  }

  public getStatusClass(status: string): string {
    const possibleStatus = [
      'Submitted',
      'Closed',
      'Pending',
      'Draft',
      'Approved',
      'Pending Approval',
      'Pending  VP, CR & CA Approval',
      'Sent To Foundation Trustee',
      'Rejected',
      'Sent To Oracle',
      'Waiting For Oracle',
      'Withdrawn',
      'Expired',
      'Paid Credit',
      'Check Cashed',
      'Check Issued',
      'Check Voided',
      'Check Cleared',
      'Cancelled',
      'Reassign to CI',
      'Pending CR&CA Approval',
      'Pending CIT Review',
      'Pending Foundation Board of Directors Review',
      'Pending CCC Review',
    ];
    // return possibleStatus.indexOf(status) > -1 ? status.toLowerCase() : '';
    // MV 06/08/2022 need to update pending VP, CR&CA to VP Communication&Corp Respon. Turn to more generic.
    return status.toLowerCase();
  }

  // public selectedRow(row: { requestNo: string; formID: any }): void {
  //   switch (row.requestNo.substring(0, 2)) {
  //     case 'CC':
  //       this.router.navigate([
  //         `/charity-forms/charitable-contribution/${row.formID}`,
  //       ]);
  //       break;
  //     case 'PP':
  //       this.router.navigate([`/charity-forms/plant-planet/${row.formID}`]);
  //       break;
  //     case 'CG':
  //       this.router.navigate([`/charity-forms/community-grant/${row.formID}`]);
  //       break;
  //     case 'ES':
  //       this.router.navigate([
  //         `/charity-forms/event-sponsorship/${row.formID}`,
  //       ]);
  //       break;
  //     case 'MG':
  //       this.router.navigate([`/charity-forms/matching-gift/${row.formID}`]);
  //       break;
  //   }
  // }

  public selectRow(row: { requestNo: string; formID: any }): void {
    if (this.isPrinting) {
      this.isPrinting = false;
      this.lgeDataService
        .DownloadFormAsPDF(row.requestNo)
        .subscribe((response: any) => {
          saveAs(response, `${row.requestNo}.pdf`);
        });
    } else {
      switch (row.requestNo.substring(0, 2)) {
        case 'CC':
          this.router.navigate([
            `/charity-forms/charitable-contribution/${row.formID}`,
          ]);
          break;
        case 'PP':
          this.router.navigate([`/charity-forms/plant-planet/${row.formID}`]);
          break;
        case 'CG':
          this.router.navigate([
            `/charity-forms/community-grant/${row.formID}`,
          ]);
          break;
        case 'ES':
          this.router.navigate([
            `/charity-forms/event-sponsorship/${row.formID}`,
          ]);
          break;
        case 'MG':
          this.router.navigate([`/charity-forms/matching-gift/${row.formID}`]);
          break;
      }
    }
  }
  getRouterLink(row: any) {
    let routerLink = [];
    switch (row.requestNo.substring(0, 2)) {
      case 'CC':
        routerLink = [`/charity-forms/charitable-contribution/${row.formID}`];
        break;
      case 'CG':
        routerLink = [`/charity-forms/community-grant/${row.formID}`];
        break;
      case 'ES':
        routerLink = [`/charity-forms/event-sponsorship/${row.formID}`];
        break;
      case 'PP':
        routerLink = [`/charity-forms/plant-planet/${row.formID}`];
        break;
    }
    return routerLink;
  }
  onPrint(row: any) {
    this.isPrinting = true;
  }

  getTaxExemptStatus(value) {
    if (value === '') return 'Other';
    else if (isNaN(value) || +value === 0) {
      return value;
    } else {
      return `501(c)(${+value})`;
    }
  }

  public applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
}

// createPDFFromBlob(pdf: Blob) {
//     let reader = new FileReader();
//     reader.addEventListener("load", () => {
//         console.log(reader.result);
//     }, false);
//     if (pdf) {
//         saveAs(pdf, `test.pdf`);
//     }
// }
